import { Component } from '@angular/core';
import { membersuiteIndividualEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Individuals') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiteindividual-form',
    templateUrl: './membersuiteindividual.form.component.html'
})
export class membersuiteIndividualFormComponent extends BaseFormComponent {
    public record!: membersuiteIndividualEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

